import { render, staticRenderFns } from "./GroupAgeSelect.vue?vue&type=template&id=1f054ea0"
import script from "./GroupAgeSelect.vue?vue&type=script&lang=ts"
export * from "./GroupAgeSelect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports